// extracted by mini-css-extract-plugin
export default {"popover":"ReleaseCategoryInlineAdd_popover__ERqFd","tag":"ReleaseCategoryInlineAdd_tag__o-xRL"};